import { render } from "./decline-attention-popup.vue?vue&type=template&id=4bc78c2d&scoped=true&ts=true"
import script from "./decline-attention-popup.vue?vue&type=script&lang=ts"
export * from "./decline-attention-popup.vue?vue&type=script&lang=ts"

import "./decline-attention-popup.vue?vue&type=style&index=0&id=4bc78c2d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc78c2d"]])

export default __exports__